// Action Types
const name = "PREMIUM_PICKS_CATALOG";
const LOAD_PREMIUM_PICKS_LIST = `${name}/LOAD_PREMIUM_PICKS_LIST`;
const IS_LOADING_PREMIUM_PICKS = `${name}/IS_LOADING_PREMIUM_PICKS`;

// Reducer
const initialState = {
  currentPicks: {},
  upcomingPicks: {},
  isLoading: true,
  loadError: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_PREMIUM_PICKS_LIST:
      return {
        ...state,
        currentPicks: action.currentPicks,
        upcomingPicks: action.upcomingPicks,
        isLoading: false,
        loadError: null
      };
    case IS_LOADING_PREMIUM_PICKS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
}

// Actions
export const fetchPremiumPicks = () => {
  return async function(dispatch) {
    dispatch({ type: IS_LOADING_PREMIUM_PICKS });

    // Temporary API endpoint for testing
    Promise.resolve($.get(`/api/v3/lists/960279561/stories`))
      .then(async apiData => {
        let apiData2 = await getSecondTestList();

        // Temporary hard-coded API data structure
        apiData.stories = apiData.stories.slice(0, 5);
        apiData2.stories = apiData2.stories.slice(0, 5);

        const data = {
          current: apiData,
          next: apiData2
        };

        dispatch({
          type: LOAD_PREMIUM_PICKS_LIST,
          currentPicks: data.current,
          upcomingPicks: data.next
        });
      })
      .catch(err => {
        dispatch({ type: LOAD_PREMIUM_PICKS_LIST, loadError: err });
      });
  };
};

function getSecondTestList() {
  return Promise.resolve($.get(`/api/v3/lists/703389905/stories`))
    .then(apiData => {
      return apiData;
    })
    .catch(() => {
      return {};
    });
}
